<template>
  <div
    @click="
      !Authentecated()
        ? $router.push({
            name: 'login',
          })
        : ''
    "
    class="main pa-md-6"
  >
    <v-row class="mx-0 px-3">
      <v-col cols="12" v-if="loadingGroup">
        <v-skeleton-loader
          v-bind="attrs"
          type="card-avatar, article, actions"
        ></v-skeleton-loader>

        <!-- <v-skeleton-loader
          v-bind="attrs"
          type="date-picker"
        ></v-skeleton-loader> -->
      </v-col>
      <v-col cols="12" v-else>
        <payment-setup-card
          v-if="
            Object.keys(group).length !== 0 &&
            paymentCardLoader &&
            verifiedAccountCondition
          "
          :group="group"
          class="my-3"
        ></payment-setup-card>
        <div>
          <group-details-card :group="group"></group-details-card>
        </div>
        <div>
          <profile-trade-detail
            v-if="Object.keys(group).length !== 0"
            :group="group"
          ></profile-trade-detail>
        </div>
      </v-col>
    </v-row>

    <reviewand-post-trade
      @trade-edit="tradeEdit"
      @reloadTrades="getTradeList(0)"
      @share-trade="shareTrade"
      :trade_review_data="trade_review_data"
      :group="group"
      v-if="trade_review_data.flag"
    />

    <v-fab-transition v-if="group.is_admin" class="floatingIcon">
      <v-btn
        color="#2D8CFF"
        dark
        class="mb-15 floatingIcon text-capitalize elevation-10"
        fixed
        rounded
        inner-height="44"
        bottom
        right
        relative
        style="z-index: 4"
        @click="addTrade()"
      >
        <v-icon small>mdi-plus</v-icon>
        <span style="font-weight: 800; letter-spacing: 0px">Add Trade</span>
      </v-btn>
    </v-fab-transition>
    <payment-detail></payment-detail>
    <expert-bank-info-modal></expert-bank-info-modal>
  </div>
</template>

<script>
import GroupDetailsCard from "@/components/GroupDetailsCard.vue";
// import GroupDetailsTradesList from "@/components/GroupDetailsTradesList.vue";
// import TradeForm from "@/components/Trade/TradeForm.vue";
import ReviewandPostTrade from "@/components/Trade/ReviewandPostTrade.vue";
import newAxios from "@/api/newAxios";
import { mapActions } from "vuex";
import apiUrl from "@/common/apiUrl";
import Axios from "@/api/BaseAxios";
// import commonFunctions from "@/common/commonFunctions";
import { isAuthenticated } from "@/common/commonFunctions.js";

export default {
  components: {
    GroupDetailsCard,
    // GroupDetailsTradesList,
    // TradeForm,
    ReviewandPostTrade,
    ProfileTradeDetail: () =>
      import("@/components/Profile/ProfileTradeDetails/ProfileTradeDetails"),
    PaymentDetail: () =>
      import("@/components/Group/PaymentDetail/PaymentDetail"),
    PaymentSetupCard: () =>
      import("@/components/Group/PaymentSetupCard/PaymentSetupCard"),
    ExpertBankInfoModal: () =>
      import("@/components/Group/ExpertBankInfoModal/ExpertBankInfoModal"),
  },

  data: () => ({
    loading: false,
    loadingGroup: false,
    Authentecated: isAuthenticated,
    trade_form_data: {
      flag: false,
      id: null,
      trade_data: {},
      trade_edit: false,
    },
    trade_review_data: {
      flag: false,
      trade_data: {},
    },
    groupId: null,
    group: {},
  }),

  async created() {
    // this.loading = true;
    // const groupId = this.$route.params.id;
    // await this.$store.dispatch("groups/fetchGroup", {
    //   groupId,
    // });
    // await this.$store.dispatch("groups/fetchGroupTrades", {
    //   groupId,
    // });
    // this.loading = false;
    this.eventBus.$on("refresh-group-detail", () => {
      this.getGroupDetail(false);
    });
  },
  beforeDestroy() {
    this.eventBus.$off("refresh-group-detail");
  },

  computed: {
    // group() {
    //   return this.$store.state.groups.group;
    // },
    paymentCardLoader() {
      return this.group.is_admin && this.group.group_type === "Premium";
    },
    verifiedAccountCondition() {
      if (!this.group.is_admin_payment_info) {
        return true;
      } else {
        if (
          this.group.admin_payment_info.verification_status === "Pending" ||
          this.group.admin_payment_info.verification_status === "Rejected"
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
  },

  methods: {
    ...mapActions({
      toggleTradeModal: "tradeData/toggleModal",
      toggleAddTradeModal: "addTrade/toggleTradeModal",
    }),
    getTradeList() {
      window.location.reload();
    },
    addTrade() {
      this.$logEvent("add_trade_group_detail_page");
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_add_trade_group_detail_page");
      }
      // this.toggleTradeModal({ show: true, type: "add", groupId: this.groupId });
      this.toggleAddTradeModal({
        show: true,
        type: "add",
        groupId: this.groupId,
      });
    },
    reviewTrade(data) {
      this.trade_review_data.trade_data = data;
      this.trade_review_data.flag = true;
    },
    getGroupDetail(value) {
      this.loadingGroup = value;
      const successHandler = (res) => {
        this.group = res.data.group_detail;
        this.$store.dispatch("groups/toggleGroupModal", res.data.group_detail);
        this.loadingGroup = false;
      };
      const failureHandler = () => {
        this.loadingGroup = false;
      };
      let formData = {};
      formData["id"] = this.groupId;
      Axios.request_GET(
        apiUrl.GROUP_DETAIL,
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    getGroupDetail2(value) {
      this.loadingGroup = value;

      const onSuccess = (res) => {
        this.group = res.data;
        this.$store.dispatch("groups/toggleGroupModal", res.data);
        this.loadingGroup = false;
      };
      const onFailure = () => {
        this.loadingGroup = false;
      };

      let params = {};
      params["id"] = this.groupId;

      newAxios("get", "api/get-group-detail", {
        params,
        onSuccess,
        onFailure,
        isTokenRequired: false,
      });
    },
  },
  mounted() {
    this.$logEvent("group_page_view");
    if (this.$vuetify.breakpoint.xsOnly) {
      this.$logEvent("mweb_group_page_view");
    }
    this.groupId = this.$route.params["id"];
    if (isAuthenticated()) {
      this.getGroupDetail(true);
    } else {
      this.getGroupDetail2(true);
    }
  },
};
</script>

<style scoped>
.main {
  min-height: 100vh;
  background: linear-gradient(
      0deg,
      rgba(45, 140, 255, 0.06),
      rgba(45, 140, 255, 0.06)
    ),
    #ffffff;
}
</style>
